export function toHex(num: number) {
  if(!num){
    return '';
  }
  // eslint:disable
  num >>>= 0;
  const b = num & 0xFF;
  const g = (num & 0xFF00) >>> 8;
  const r = (num & 0xFF0000) >>> 16;
  return '#' + [r, g, b].map((component) => { return hexToDigit(component) }).join('');
  // eslint:enable
}

function hexToDigit(num: number) { //eslint:disable-line
  let str = num.toString(16);
  if (str.length < 2) {
  str = '0' + str;
  }
  return str;
}
